<script>
  import { getContext, onMount } from 'svelte';
  import { fade, fly } from 'svelte/transition';
 
  import {SEARCH_HOUSEHOLDS} from '../../graphql/households';
  
  const client = getContext('apollo');

  import Loader from '../../components/ui/loader.html';
  import Household from './components/household.html';
  import Plus from '../../components/buttons/plus';
  import Link from '../../utils/link';
  import Search from '../../components/inputs/search';
  import LoadMore from '../../components/buttons/loadmore';

  let search = '';
  let query = client.watchQuery({ query: SEARCH_HOUSEHOLDS, variables: {search} });
  let results = {loading: true};

  function setResponse({data, loading, error, networkStatus}) {
    results = {
      loading,
      pages: data && data.households ? data.households.pages : 1,
      page: data && data.households ? data.households.page : 1,
      total: data && data.households ? data.households.total : 0,
      households: data && data.households ? data.households.docs : []
    }
  }

  const subscription = query.subscribe({
    next: nextResult => {
      setResponse(nextResult);
    },
    error: error => {
      setResponse({error, loading: false});
    }
  });

  function searchHouseholds() {
    query.refetch({search, page: 1});
  }

  function loadMore() {
    query.fetchMore({
      variables: {
        search,
        page: results.page + 1
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return Object.assign({}, prev, {
          households: {
            ...fetchMoreResult.households,
            docs: [...prev.households.docs, ...fetchMoreResult.households.docs]
          }
        });
      }
    });
  }
</script>




<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <h1>{results.total || 0} Households</h1>
  </div>
  <div class="cell small-12 medium-12">
    <Search on:input={searchHouseholds} bind:value={search} placeholder={'Search Households'}  />
  </div>
  <div class="cell small-12 medium-12">
    {#if results.loading}
      <Loader></Loader>
    {/if}
    {#if !results.loading}
      <div class="grid-x grid-margin-x small-up-1 medium-up-2">
        {#each results.households as household, i}
          <div class="cell">
            <Household household={household} />
          </div>
        {/each}
      </div>
    {/if}
  </div>
  <div class="cell small-12 text-center">
    {#if !results.loading && results.page !== results.pages}<LoadMore on:click={loadMore} />{/if}
  </div>
</div>
